import { render } from "./MbFeatureSelect.vue?vue&type=template&id=24f171f4&scoped=true"
import script from "./MbFeatureSelect.vue?vue&type=script&lang=js"
export * from "./MbFeatureSelect.vue?vue&type=script&lang=js"

import "./MbFeatureSelect.vue?vue&type=style&index=0&id=24f171f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24f171f4"

export default script